import React from 'react';
import { connect } from 'react-redux'
import CrearCircuitoEstados from './CrearCircuitoEstados.js';

import {
    getScreenData,
    cambiarCombo,
    inicioCreacion,
    asignarNombreEstado,
    siguenteEstado,
    asignarDocumentacionAEstado,
    actualizarCantidadEstadosSalida,
    asignarEstadoDeSalida,
    cancelarEdicion,
    finalizarCreacion
} from '../actions/Actions.js';

let _cliente;

const mapStateToProps = (state) => {
    _cliente = state.tarjetas.clienteResultadoBusqueda;

    return {
        data: state.CrearCircuitoEstados,
        plasticos: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (state, currentScope) => {
            dispatch(getScreenData(state, currentScope));
        },
        cambiarCombo: (value, type) => {
            dispatch(cambiarCombo(value, type));
        },
        inicioCreacion: () => {
            dispatch(inicioCreacion());
        },
        asignarNombreEstado: (estadoNombre, estadoNro) => {
            dispatch(asignarNombreEstado(estadoNombre, estadoNro));
        },
        siguenteEstado: (type) => {
            dispatch(siguenteEstado(type));
        },
        asignarDocumentacionAEstado: (idDocumentacion, estado) => {
            dispatch(asignarDocumentacionAEstado(idDocumentacion, estado));
        },
        actualizarCantidadEstadosSalida: (cantidad, estado) => {
            dispatch(actualizarCantidadEstadosSalida(cantidad, estado));
        },
        asignarEstadoDeSalida: (estado, estadoSalida, estadoSeleccionado) => {
            dispatch(asignarEstadoDeSalida(estado, estadoSalida, estadoSeleccionado));
        },
        cancelarEdicion: () => {
            dispatch(cancelarEdicion());
        },
        finalizarCreacion: (data) => {
            dispatch(finalizarCreacion(data));
        }
    }
}

class CrearCircuitoEstadosContainer extends React.Component {
    componentDidMount() {
        this.props.getScreenData(this.props.routeState, this.props.currentScope);
    }

    render() {
        return (
            <CrearCircuitoEstados
                //Reducers...
                data={this.props.data}
                plasticos={this.props.plasticos}

                cambiarCombo={this.props.cambiarCombo}
                inicioCreacion={this.props.inicioCreacion}
                asignarNombreEstado={this.props.asignarNombreEstado}
                siguenteEstado={this.props.siguenteEstado}
                asignarDocumentacionAEstado={this.props.asignarDocumentacionAEstado}
                actualizarCantidadEstadosSalida={this.props.actualizarCantidadEstadosSalida}
                asignarEstadoDeSalida={this.props.asignarEstadoDeSalida}
                cancelarEdicion={this.props.cancelarEdicion}
                finalizarCreacion={this.props.finalizarCreacion}
            />
        );
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(CrearCircuitoEstadosContainer);
